export type BroadcastChannel = 'email' | 'notification' | 'push' | 'banner' | 'whatsapp';
export type BroadcastTargetType = 'all' | 'plan' | 'status' | 'radio' | 'email' | 'country' | 'category' | 'storage' | 'renewal';
export type BroadcastStatus = 'draft' | 'scheduled' | 'sent' | 'cancelled';

export interface BroadcastMessage {
  id: number;
  subject: string;
  body: string;
  targetType: BroadcastTargetType;
  targetValue: string;
  targetLabel: string;
  channel: BroadcastChannel;
  sentCount: number;
  deliveredCount: number;
  openedCount: number;
  sentAt: string;
  sender: string;
  status: BroadcastStatus;
  scheduledAt: string | null;
  createdAt: string;
}

export const broadcastChannels: { value: BroadcastChannel; label: string; icon: string; badge: string; available: boolean }[] = [
  { value: 'email', label: 'Email', icon: 'ri-mail-line', badge: 'Activo', available: true },
  { value: 'notification', label: 'Notificación interna', icon: 'ri-notification-3-line', badge: 'Activo', available: true },
  { value: 'push', label: 'Push (futuro)', icon: 'ri-smartphone-line', badge: 'Próximamente', available: false },
  { value: 'banner', label: 'Banner admin', icon: 'ri-layout-top-line', badge: 'Activo', available: true },
  { value: 'whatsapp', label: 'WhatsApp (futuro)', icon: 'ri-whatsapp-line', badge: 'Próximamente', available: false },
];

export const broadcastTargetOptions = [
  { value: 'all', label: 'Todas las radios', icon: 'ri-global-line', type: 'all' as const },
  { value: 'radio_specific', label: 'Radio específica', icon: 'ri-radio-line', type: 'radio' as const },
  { value: 'email_manual', label: 'Correo manual', icon: 'ri-mail-line', type: 'email' as const },
  { value: 'plan_free', label: 'Radios Free', icon: 'ri-funds-line', type: 'plan' as const },
  { value: 'plan_pro', label: 'Radios Pro', icon: 'ri-star-fill', type: 'plan' as const },
  { value: 'plan_premium', label: 'Radios Premium', icon: 'ri-vip-diamond-fill', type: 'plan' as const },
  { value: 'country_select', label: 'Por país', icon: 'ri-earth-line', type: 'country' as const },
  { value: 'category_select', label: 'Por categoría', icon: 'ri-price-tag-3-line', type: 'category' as const },
  { value: 'status_pending', label: 'Radios pendientes', icon: 'ri-hourglass-line', type: 'status' as const },
  { value: 'status_trial', label: 'Radios en trial', icon: 'ri-timer-line', type: 'status' as const },
  { value: 'status_stream_down', label: 'Radios con stream caído', icon: 'ri-signal-wifi-off-line', type: 'status' as const },
  { value: 'storage_high', label: 'Radios con storage alto', icon: 'ri-hard-drive-2-line', type: 'storage' as const },
  { value: 'renewal_upcoming', label: 'Radios próximas a renovar', icon: 'ri-calendar-check-line', type: 'renewal' as const },
];

export const countryOptions = [
  'Argentina', 'Chile', 'Colombia', 'Costa Rica', 'Ecuador', 'El Salvador',
  'España', 'Estados Unidos', 'México', 'Panamá', 'Paraguay', 'Perú',
  'Puerto Rico', 'Uruguay', 'Venezuela',
];

export const categoryOptions = [
  'Pop / Variado', 'Latina / Salsa', 'Éxitos / Top 40', 'Fiesta / Electrónica',
  'Rock / Alternativo', 'Regional Mexicano', 'Urbano / Reguetón', 'Clásica / Instrumental',
  'Hip Hop / Rap', 'Noticias / Debate', 'Llanera / Folclor', 'Indie / Alternativo',
  'Festival / En Vivo', 'Tropical / Cumbia', 'Pop / Juvenil', 'Folclor / Andina',
  'Retro / Clásicos', 'Electrónica / Techno', 'Deportes', 'Gospel / Cristiana',
  'House / Deep', 'Tropical / Merengue',
];

export const broadcastMessages: BroadcastMessage[] = [
  {
    id: 1,
    subject: 'Mantenimiento programado - 15 de junio',
    body: 'El próximo 15 de junio realizaremos tareas de mantenimiento entre las 2:00 y 4:00 AM. Durante ese período algunos servicios podrían experimentar intermitencias. Recomendamos no programar transmisiones en vivo durante esa ventana.',
    targetType: 'all',
    targetValue: 'all',
    targetLabel: 'Todas las radios (22)',
    channel: 'email',
    sentCount: 22,
    deliveredCount: 22,
    openedCount: 18,
    sentAt: '2026-06-04 10:30',
    sender: 'Carlos Mendoza',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-06-04 09:00',
  },
  {
    id: 2,
    subject: 'Nuevo módulo de Eventos disponible',
    body: 'Acabamos de lanzar el módulo de Eventos. Ahora podés crear y gestionar eventos desde tu panel de administración. Ideal para conciertos, entrevistas y programación especial. ¡Revisalo en Admin > Eventos!',
    targetType: 'plan',
    targetValue: 'plan_pro',
    targetLabel: 'Radios Pro (5)',
    channel: 'notification',
    sentCount: 5,
    deliveredCount: 5,
    openedCount: 5,
    sentAt: '2026-05-28 15:00',
    sender: 'Ana López',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-05-28 12:30',
  },
  {
    id: 3,
    subject: 'Tu stream está caído - Acción requerida',
    body: 'Hemos detectado que tu stream no está respondiendo. Por favor verificá tu configuración de streaming o contactá a soporte para asistencia. Si necesitás ayuda técnica, respondé este mensaje.',
    targetType: 'status',
    targetValue: 'status_stream_down',
    targetLabel: 'Radios con stream caído (2)',
    channel: 'email',
    sentCount: 2,
    deliveredCount: 2,
    openedCount: 2,
    sentAt: '2026-06-05 08:00',
    sender: 'Sistema Automático',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-06-05 08:00',
  },
  {
    id: 4,
    subject: 'Recordatorio: completá tu perfil',
    body: 'Las radios con perfil completo tienen 3x más oyentes. Completá tu información, agregá fotos y mejorá tu presencia en la plataforma. Vas a aparecer mejor rankeado en búsquedas y recomendaciones.',
    targetType: 'status',
    targetValue: 'status_pending',
    targetLabel: 'Radios pendientes (3)',
    channel: 'banner',
    sentCount: 3,
    deliveredCount: 3,
    openedCount: 2,
    sentAt: '2026-06-01 12:00',
    sender: 'Carlos Mendoza',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-06-01 10:00',
  },
  {
    id: 5,
    subject: 'Promoción especial: 50% OFF primer mes de Premium',
    body: 'Solo por tiempo limitado, actualizate a Premium con 50% de descuento en tu primer mes. Desbloqueá 500 GB, API, Lives ilimitados, dominio propio y mucho más. Válido hasta el 30 de junio.',
    targetType: 'plan',
    targetValue: 'plan_free',
    targetLabel: 'Radios Free (9)',
    channel: 'email',
    sentCount: 9,
    deliveredCount: 9,
    openedCount: 7,
    sentAt: '2026-05-20 09:00',
    sender: 'Ana López',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-05-19 16:00',
  },
  {
    id: 6,
    subject: 'Actualización de términos y condiciones',
    body: 'Hemos actualizado nuestros términos y condiciones de la plataforma. Los cambios entran en vigencia el 1 de julio de 2026. Te recomendamos revisarlos en https://radiofrecuenciaweb.com/terms.',
    targetType: 'all',
    targetValue: 'all',
    targetLabel: 'Todas las radios (22)',
    channel: 'email',
    sentCount: 22,
    deliveredCount: 22,
    openedCount: 15,
    sentAt: '2026-06-08 14:00',
    sender: 'Carlos Mendoza',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-06-08 11:30',
  },
  {
    id: 7,
    subject: 'Feliz aniversario RadioFrecuenciaWeb',
    body: '¡Cumplimos 3 años! Gracias por ser parte de esta comunidad. Para celebrarlo, liberamos nuevas funcionalidades: estadísticas avanzadas, centro de broadcast y más. ¡Gracias por confiar en nosotros!',
    targetType: 'country',
    targetValue: 'country_mexico',
    targetLabel: 'Radios en México (5)',
    channel: 'notification',
    sentCount: 5,
    deliveredCount: 5,
    openedCount: 5,
    sentAt: '2026-06-10 10:00',
    sender: 'Ana López',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-06-09 18:00',
  },
  {
    id: 8,
    subject: 'Webinar: Monetizá tu radio online',
    body: 'Te invitamos al webinar exclusivo "Monetizá tu radio online" este viernes 20 de junio a las 18:00. Aprendé estrategias de publicidad, auspiciantes y membresías. Cupos limitados, reservá ya.',
    targetType: 'plan',
    targetValue: 'plan_pro',
    targetLabel: 'Radios Pro (5)',
    channel: 'email',
    sentCount: 0,
    deliveredCount: 0,
    openedCount: 0,
    sentAt: 'Programado: 2026-06-17 09:00',
    sender: 'Carlos Mendoza',
    status: 'scheduled',
    scheduledAt: '2026-06-17T09:00',
    createdAt: '2026-06-10 15:30',
  },
  {
    id: 9,
    subject: 'Alerta de storage: estás cerca del límite',
    body: 'Tu radio está usando más del 85% del almacenamiento asignado. Considerá liberar espacio eliminando archivos antiguos o actualizá tu plan para obtener más capacidad.',
    targetType: 'storage',
    targetValue: 'storage_high',
    targetLabel: 'Radios con storage > 80% (3)',
    channel: 'email',
    sentCount: 0,
    deliveredCount: 0,
    openedCount: 0,
    sentAt: 'Borrador',
    sender: 'Sistema Automático',
    status: 'draft',
    scheduledAt: null,
    createdAt: '2026-06-10 08:00',
  },
  {
    id: 10,
    subject: 'Pronto vence tu licencia anual',
    body: 'Tu licencia anual de RadioFrecuenciaWeb vence en 30 días. Renová ahora para mantener todos tus beneficios sin interrupción. Si dejás vencer, tu radio pasará a estado suspendida.',
    targetType: 'renewal',
    targetValue: 'renewal_upcoming',
    targetLabel: 'Radios próximas a renovar (4)',
    channel: 'email',
    sentCount: 0,
    deliveredCount: 0,
    openedCount: 0,
    sentAt: 'Programado: 2026-06-20 08:00',
    sender: 'Sistema Automático',
    status: 'scheduled',
    scheduledAt: '2026-06-20T08:00',
    createdAt: '2026-06-11 07:00',
  },
  {
    id: 11,
    subject: 'Nueva categoría: Podcasts y on-demand',
    body: 'Estrenamos la sección de Podcasts en tu panel. Ahora podés subir episodios grabados, organizarlos por temporadas y monetizarlos. Ideal para entrevistas, debates y contenido exclusivo.',
    targetType: 'category',
    targetValue: 'category_noticias',
    targetLabel: 'Categoría Noticias/Debate (1)',
    channel: 'banner',
    sentCount: 1,
    deliveredCount: 1,
    openedCount: 1,
    sentAt: '2026-06-03 11:00',
    sender: 'Ana López',
    status: 'sent',
    scheduledAt: null,
    createdAt: '2026-06-03 09:45',
  },
  {
    id: 12,
    subject: 'Nuevas integraciones sociales disponibles',
    body: 'Ahora podés conectar tu radio con Instagram, TikTok, YouTube y Twitch desde Social Connect. Publicá automáticamente cuando iniciás un live y ganá más audiencia.',
    targetType: 'all',
    targetValue: 'all',
    targetLabel: 'Todas las radios (22)',
    channel: 'notification',
    sentCount: 0,
    deliveredCount: 0,
    openedCount: 0,
    sentAt: 'Borrador',
    sender: 'Carlos Mendoza',
    status: 'draft',
    scheduledAt: null,
    createdAt: '2026-06-11 09:00',
  },
];